import React, { Component } from 'react';
import { LoadingStatus } from '../../../redux/reducers/LoadingStatusReducer';
import InquiryDate from '../../../container/molecules/InquiryDateContainer';
import ScreenName from '../../../component/molecules/ScreenName';
import classNames from 'classnames';
import AnnotationTooltip, { AnnotationTooltipProps } from '../../molecules/AnnotationTooltip';
import { GASpotEventState } from '../NegotiationCountList';

export interface ContentHeaderProps {
  screenId: string;
  screenName: string;
  statusType: string;
  loadingStatus: LoadingStatus;
  className?: string;
  titleIcon?: React.ReactNode;
  tooltipInfo?: AnnotationTooltipProps;
  gaSpotEvent?: GASpotEventState;
  customRefresh?: () => void;
}

class ContentHeader extends Component<ContentHeaderProps, {}> {
  constructor(props: ContentHeaderProps) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className={classNames('clearfix', this.props.className)}>
        {this.props.titleIcon}
        <ScreenName screenId={this.props.screenId} screenName={this.props.screenName} />
        {this.props.tooltipInfo && (
          <AnnotationTooltip
            content={this.props.tooltipInfo.content}
            url={this.props.tooltipInfo.url}
            label={this.props.tooltipInfo.label}
          />
        )}
        <InquiryDate
          screenId={this.props.screenId}
          jobDateTime={this.props.loadingStatus.result?.jobDateTime}
          isLoading={this.props.loadingStatus.isLoading}
          error={this.props.loadingStatus.error}
          gaSpotEvent={this.props.gaSpotEvent}
          customRefresh={this.props.customRefresh}
        />
        <div className='u-float-right'>{this.props.children}</div>
      </div>
    );
  }
}

export default ContentHeader;
